require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/set-immediate.js
// module id = 98
// module chunks = 0